import devisResumeBo from './DevisResume';
import clientResumeBo from './ClientResume';
import devisParamsBo from './DevisParams';
import devisContentBo from './DevisContent';
import devisNewProductBo from './DevisNewProduct';

export default class devisBo {
    _resume = null;
    _client = null;
    _params = null;
    _content = null;
    _productsAdded = null;

    constructor() {
        this._resume = Object.assign({}, devisResumeBo);
        this._client = Object.assign({}, clientResumeBo);
        this._params = Object.assign({}, devisParamsBo);
        this._content = [];
        this._productsAdded = [];
    }

    get resume() {
        return this._resume;
    }

    get client() {
        return this._client;
    }

    get params() {
        return this._params;
    }

    set params(newParams) {
        this._params = newParams;
    }

    get content() {
        return this._content;
    }

    get productsAdded() {
        return this._productsAdded;
    }
}


// WEBPACK FOOTER //
// ./src/components/data/devis/Devis.js